__webpack_require__.p = "/foodwaste/";